import { render, staticRenderFns } from "./AlBum.vue?vue&type=template&id=0bda0178&scoped=true"
import script from "./AlBum.vue?vue&type=script&setup=true&lang=js"
export * from "./AlBum.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlBum.vue?vue&type=style&index=0&id=0bda0178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda0178",
  null
  
)

export default component.exports